import React from 'react';
import styled from 'styled-components';
import FacebookIcon from '@material-ui/icons/Facebook';
import GithubIcon from '@material-ui/icons/GitHub';
import YoutubeIcon from '@material-ui/icons/YouTube';

// import logo from './../logo.svg';
// import './../App.css';

function HomePage() {
  return (
        <HomePageStyled>
            <div className="typography">
                <p>Welcome to the home of Big Dog Properties!</p>
                <div className="icons">
                    <a className="icon i-facebook" href="https://facebook.com">
                        <FacebookIcon/>
                    </a>
                    <a className="icon i-github" href="https://github.com">
                        <GithubIcon/>
                    </a>
                    <a className="icon i-youtube" href="https://youtube.com">
                        <YoutubeIcon />
                    </a>
                </div>
            </div>
        </HomePageStyled>
  );
}

export default HomePage;




const HomePageStyled = styled.header`
    width:100%;
    height: 100vh;
    position:relative;
    background-image: linear-gradient( rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5) ),url(${props => props.img});
    /* background-image: "../img/aurora.jpg"; */
    .typography{
        position:absolute;
        top:50%;
        left:50%;
        transform:translate(-50%,-50%);
        width:80%;
        .icons{
            display:flex;
            justify-content:center;
            .icon{
                border:solid 2px var(--border-color);
                display:flex;
                border-radius:50%;
                margin-top:1rem;
                align-items:center;
                justify-content:center;
                transition: All .4s ease-in-out;
                &:hover{
                    cursor: pointer;
                    color:var(--primary-color);
                    border:solid 2px var(--primary-color);
                }
                &:not(:last-child){
                    margin-right:1rem;
                    
                }
                svg{
                    margin:.5rem;
                }
            }
            .i-youtube{
                    &:hover{
                        color:red;
                    border:solid 2px red;
                    }
                }
            .i-github{
                &:hover{
                        color:purple;
                    border:solid 2px purple;
                }
            }
        }
    }
    h1{
        font-size:3rem;
        color:var(--white-color);
        span{
            font-size:3rem;
            color:var(--primary-color);
        }
    }
`;
